import {useState} from "react";
import {InputGroup, Button, Form} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const CopyToClipTextarea = ({value, rows = 5}) => {
    const [copyStatus, setCopyStatus] = useState("idle"); // idle, success, error

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(value);
            setCopyStatus("success");
            setTimeout(() => setCopyStatus("idle"), 2000);
        } catch (err) {
            setCopyStatus("error");
            setTimeout(() => setCopyStatus("idle"), 2000);
        }
    };

    const getButtonConfig = () => {
        switch (copyStatus) {
            case "success":
                return {
                    text: <FontAwesomeIcon icon="clone" />,
                    variant: "outline-success",
                };
            case "error":
                return {
                    text: <FontAwesomeIcon icon="clone" />,
                    variant: "outline-danger",
                };
            default:
                return {
                    text: <FontAwesomeIcon icon="clone" />,
                    variant: "outline-secondary",
                };
        }
    };

    const buttonConfig = getButtonConfig();

    return (
        <InputGroup>
            <Form.Control
                as="textarea"
                defaultValue={value}
                readOnly={true}
                rows={rows}
            />
            <Button
                variant={buttonConfig.variant}
                onClick={handleCopy}
                disabled={!value}>
                {buttonConfig.text}
            </Button>
        </InputGroup>
    );
};

export default CopyToClipTextarea;
